import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import { Signal, LanguageNameSpaces } from "@shared/types";
import Dropdown from "common/Dropdown/Dropdown";
import { useSignalAdminActions } from "features/signals/common/hooks.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { useTheme } from "styled-components";
import NewLookKebab from "features/portfolio/NewLook/NewLookKebab.tsx";

interface SignalActionsDropdownProps {
  signal: Signal;
}

const SignalActionsDropdown = ({ signal }: SignalActionsDropdownProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SIGNALS);
  const { isNewLook } = useTheme();
  const { menuItems, cancelSignalModal } = useSignalAdminActions(
    signal.signal_id
  );

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown
        title={t("actions.signal_actions")}
        menu={{ items: menuItems }}
        trigger={["click"]}
      >
        {isNewLook ? (
          <NewLookKebab aria-label={t("actions.signal_actions")} />
        ) : (
          <EllipsisOutlined
            style={{
              cursor: "pointer",
              fontSize: "30px",
              transform: "rotate(90deg)",
            }}
          />
        )}
      </Dropdown>
      {cancelSignalModal}
    </div>
  );
};

export default SignalActionsDropdown;
